import { render, staticRenderFns } from "./UserEditTabSettings.vue?vue&type=template&id=48007ef6&"
import script from "./UserEditTabSettings.vue?vue&type=script&lang=js&"
export * from "./UserEditTabSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabSettings.vue?vue&type=style&index=0&id=48007ef6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports